export class CsvMappingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCsvMappingPropertiesList({ mappingDefinitionId }) {
    return this.#http.get(`/CsvMapping/${mappingDefinitionId}/properties`);
  }

  async getCsvMappingMetadata() {
    return this.#http.get('/CsvMapping/metadata');
  }

  async editCsvMappingUpdateProperties({ mappingDefinitionId, list }) {
    return this.#http.put(`/CsvMapping/${mappingDefinitionId}/updateProperties`, list);
  }

  async createCsvMappingExampleFile({ formData, ...params }) {
    return this.#http.post('/CsvMapping/example/file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params,
    });
  }

  async createCsvMappingExportRows({ formData, entityType, entityId }) {
    return this.#http.post(`/CsvMapping/export/rows/${entityType}/${entityId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
